import React from 'react';
import './ContactForm.less';
import { Form, Input, Yup, Textarea } from '111-react-simpleform';
import Axios from 'axios';
import Button from '../../../common/js/app/Button/Button.jsx';
import { Link } from 'react-router';

const API_URL = 'https://auth-dot-worldspaceschool-stg.appspot.com';

type Props = {

}

const formName = 'contactForm';

const strings = {
  title: 'Ready to launch ?',
  name: 'Name',
  email: 'Email',
  organisation: 'Organisation',
  country: 'Country',
  message: 'Message',
  send: 'Send',
  sending: 'Sending',
  sent: 'Sent'
};

const schema = Yup.object().shape({
  name: Yup.string().min(2).max(64).required(),
  email: Yup.string().email().required(),
  organisation: Yup.string().min(2).max(64),
  country: Yup.string().min(2).max(64),
  message: Yup.string().min(2).max(2048)
});

class ContactForm extends React.Component {

  description: 'Top page contact form, linked to netlify ajax submission.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.state = {
      status: 'READY',
      error: null
    };
  }

  /* Component Custom Methods */
  handleSubmit = (contactData, e) => {
    this.setState({status: 'SAVING'});
    Axios.post(`${API_URL}/contact`, contactData).then(() => {
      this.setState({status: 'SUCCESS'});
    }).catch((e) => {
      this.setState({
        loading: false,
        error: e.message
      });
    });

  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="contact-form cacher">
        <p className="error">{ this.state.error }</p>
        <h3 className="m-b-xl" >{ strings.title }</h3>
        <Form
          data-netlify={ true }
          disabled={ this.state.status !== 'READY' }
          onSubmit={ this.handleSubmit }
          schema={ schema }
        >
          <Input
            label={ strings.name }
            name="name"
            type="text"
          />
          <Input
            label={ strings.email }
            name="email"
            type="email"
          />
          <Input
            label={ strings.organisation }
            name="organisation"
            type="text"
          />
          <Input
            label={ strings.country }
            name="country"
            type="text"
          />
          <Textarea
            label={ strings.message }
            name="message"
          />
          <div className="text-right m-t">
          <p className="m-b">By clicking the Send button, you agree to our <Link target="_blank" to="/privacy">Privacy Policy</Link></p>
            <Button
              type="submit"
              disabled={ this.state.status !== 'READY' }
              saving={ strings.sending }
              success={ strings.sent }
              state={ this.state.status }
            >{ strings.send }</Button>
          </div>
        </Form>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default ContactForm;

//Unit test entry point
export const ContactFormTest = ContactForm;


/** WEBPACK FOOTER **
 ** ./src/js/contact/ContactForm/ContactForm.jsx
 **/